import React , { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import api from '../../service/api';
import {
  Paper, Tooltip, IconButton, TablePagination, Button, Typography,
  Stack, Box,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem
} from '@mui/material';
import ProgressBar from '../progress/progressBar';
import HomeIcon from '@mui/icons-material/Home';
import CONSTANT from '../../Constant/Constant';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextField from '@mui/material/TextField';
import './TrackRequest.css';
import SearchIcon from '@mui/icons-material/Search';
import { DirectionContext } from '../../context/DirectionProvider';
import UserContext from '../../context/user';

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return `${year}-${month}-${day}`;
};

const INTERVALS = {
  'Last 7 Days': { unit: 'days', value: 7 },
  'Last 15 Days': { unit: 'days', value: 15 },
  'Last 1 Month': { unit: 'months', value: 1 },
  'Last 3 Months': { unit: 'months', value: 3 },
  'All': { unit: 'days', value: 0 } // Special case for "All" to fetch all data
};

const getDateRangeForInterval = (interval) => {
  const endDate = new Date();
  const { unit, value } = INTERVALS[interval];

  const startDate = new Date(endDate);
  if (unit === 'months') {
    startDate.setMonth(startDate.getMonth() - value);
  } else {
    startDate.setDate(startDate.getDate() - value);
  }

  return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
};

const TrackRequest = (props) => {
  const [activeTab, setActiveTab] = useState("VendorRequest");
  const history = useHistory();
  const [data, setData] = React.useState(props.data);
  const [progressFlag, setProgressFlag] = useState(true);
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [firstResponse, setFirstResponse] = useState([]);
  const [secondResponse, setSecondResponse] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [paginationDisabled, setPaginationDisabled] = useState(false);
  const [filteredVendorData, setFilteredVendorData] = useState([]);
  const [filteredReltioData, setFilteredReltioData] = useState([]);  
  const [isAdmin, setIsAdmin] = useState(false)
  const [multimatchAccess, setMultimatchAccess] = useState(false)
  const direction = useContext(DirectionContext);
  const userInfo = useContext(UserContext);
  const canAccessHcaRequests = Boolean(userInfo?.canAccessHCARequests);


  const [searchData, setSearchData] = useState({ timeInterval: 'Last 7 Days', ...getDateRangeForInterval('Last 7 Days') })

  const handleTimeIntervalChange = (event) => {
    const interval = event.target.value;
    setSearchData({ timeInterval: interval, ...getDateRangeForInterval(interval) });
    setSearchTerm('');
    setPage(0);
  };

  const handleVendorRequest = () => {
    setActiveTab("VendorRequest");
    setPage(0);
  };

  const handleReltioRequest = () => {
    setActiveTab("ReltioRequest");
    setPage(0);
  };

  const handleSearch = (event) => {
    // normalize and use current typed value; reset to first page for new search
    const term = String(event.target.value || '').toLowerCase();
    setSearchTerm(term);
    setPage(0);

    const vendorFilteredData = (vendorTabData || []).filter((row) =>
      (String(row.Id || '').toLowerCase().includes(term)) ||
      (String(row.CreatedDate || '').toLowerCase().includes(term)) ||
      (String(row.UpdatedDate || row.updateTime || '').toLowerCase().includes(term)) ||
      (String(row.state || '').toLowerCase().includes(term)) ||
      (String(row.RequestType || '').toLowerCase().includes(term)) ||
      (String(row.Country || row.country || '').toLowerCase().includes(term))
    );
    setFilteredVendorData(vendorFilteredData);

    const reltioFilteredData = (reltioTabData || []).filter((row) =>
      (String(row.Id || '').toLowerCase().includes(term)) ||
      (String(row.CreatedDate || '').toLowerCase().includes(term)) ||
      (String(row.UpdatedDate || '').toLowerCase().includes(term)) ||
      (String(row.state || '').toLowerCase().includes(term)) ||
      (String(row.RequestType || '').toLowerCase().includes(term))||
      (String(row.Country || row.country || '').toLowerCase().includes(term))
    );
    setFilteredReltioData(reltioFilteredData);

    setPaginationDisabled(!!term);
  };

  const handleError = (error) => {
    setErrorFlag(true);
    let errorDetail = error;
    let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
    setErrorMsg(msg ? msg : 'Internal Server Error!');
    setProgressFlag(false)
  };


  const getStatusClassdcr = (state) => {
    switch (state) {
      case CONSTANT.STATE[0]:
        return 'text-white rounded py-2 px-3 bg-primary';
      case CONSTANT.STATE[1]:
        return 'text-white rounded py-2 px-3 bg-success';
      case CONSTANT.STATE[2]:
        return 'text-white rounded py-2 px-3 bg-danger';
      case CONSTANT.STATE[3]:
        return 'text-white rounded py-2 px-3 bg-warning';
      case CONSTANT.STATE[4]:
        return 'text-white rounded py-2 px-3 bg-primary';
      case CONSTANT.STATE[5]:
        return 'text-white rounded py-2 px-3 bg-success';
      case CONSTANT.STATE[6]:
        return 'text-white rounded py-2 px-3 bg-danger';
      case CONSTANT.STATE[7]:
        return 'text-white rounded py-2 px-3 bg-success';
      case 'AWAITING_REVIEW':
        return 'text-white rounded py-2 px-3 bg-primary';
      case CONSTANT.STATE[9]:
        return 'text-white rounded py-2 px-3 bg-success';
      case 'Partially Approved':
        return 'text-white rounded py-2 px-3 approvedButton';
      default:
        return 'text-white rounded py-2 px-3 bg-primary';
    }
  }

  const goToHome = () => {
    props.history.push('/');
  }

  const goBack = () => {
    props.history.goBack();
  };

  const handleChangePage = (event, newPage) => {
    // if (searchTerm) {
    //   return;
    // }
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  let combinedState = [...firstResponse, ...secondResponse];
  combinedState.sort((a, b) => {
    if (moment.utc(new Date(a.createdTime || a.CreatedDate)).isAfter(moment.utc(new Date(b.createdTime || b.CreatedDate)))) {
      return -1;
    } else {
      return 1;
    }
  })

  const vendorTabData = (combinedState.filter(el => el.endsource === 'VENDOR'));
  const reltioTabData = (combinedState.filter(el => el.endsource === 'EPH'));

  const vendorIndexStart = page * rowsPerPage;
  const vendorIndexEnd = page * rowsPerPage + rowsPerPage;
  const vendorDataPaginated = searchTerm && filteredVendorData ? filteredVendorData.slice(vendorIndexStart, vendorIndexEnd):  vendorTabData.slice(vendorIndexStart, vendorIndexEnd);

  const reltioIndexStart = page * rowsPerPage;
  const reltioIndexEnd = page * rowsPerPage + rowsPerPage;
  const reltioDataPaginated = searchTerm && filteredReltioData ? filteredReltioData.slice(reltioIndexStart, reltioIndexEnd) : reltioTabData.slice(reltioIndexStart, reltioIndexEnd);

  useEffect(() => {
    fetchData()
  }, [searchData.startDate, searchData.endDate]);

  async function fetchData() {
    setProgressFlag(true)
    // if (searchData.timeInterval === 'All') just send getAllRequest without parameters to fetch all data, otherwise send the date range

    if (searchData.timeInterval === 'All') {
      await api
        .getAllRequest()
        .then(response => {
          let ApiResponse = response.data
          setIsAdmin(ApiResponse.isUserTracker)
          setMultimatchAccess(ApiResponse.multimatch_access)
          setSecondResponse(ApiResponse.response)
        })
        .catch(error => {
          handleError(error)
        })
        .finally(() => setProgressFlag(false))
    } else {
      await api
        .getAllRequest(null, null, null, null, { requestPage: 'myDcr', startDate: searchData.startDate, endDate: searchData.endDate })
        .then(response => {
          let ApiResponse = response.data
          setIsAdmin(ApiResponse.isUserTracker)
          setMultimatchAccess(ApiResponse.multimatch_access)
          setSecondResponse(ApiResponse.response)
        })
        .catch(error => {
          handleError(error)
        })
        .finally(() => setProgressFlag(false))
    }
  };

  return (

    <section className={"container body-height extra-margin-top-less"}>
      {
        progressFlag
        &&
        <div className="d-flex justify-content-center extra-margin-top">
          <ProgressBar />
        </div>
      }
      {
        !progressFlag &&
        <>
         <Paper square className='mb-2'>
            <Stack direction={'row'} gap={0} justifyContent={'space-between'} alignItems={'center'}>
              <div className="tabdata">
                <ul className="nav">
                  <li id="track-head"
                    className={`${activeTab==='VendorRequest'? 'active':''} _wg-exclude`}
                    onClick={handleVendorRequest}
                  >
                    Vendor DCR
                  </li>
                  <li id="track-head"
                    className={`${activeTab==='ReltioRequest'?'active':''} _wg-exclude`}
                    onClick={handleReltioRequest}
                  >
                    Lilly DCR
                  </li>
                </ul>
              </div>
              <Stack direction={'row'} gap={1}>
              {isAdmin &&
                <Button className='linkButton' onClick={() => history.push(`/track-all-request`)}>Track all DCRs</Button>
              }

              {canAccessHcaRequests && <>
                <span style={{ lineHeight: '35px', color: '#c1bfbb' }}>&bull;</span>
                <Button className='linkButton' onClick={() => history.push(`/track-hca`)}>Track HCA Requests</Button>
              </>}

                {multimatchAccess && <>
                  <span style={{ lineHeight: '35px', color: '#c1bfbb' }}>&bull;</span>
                  <Button className='linkButton' component={Link} to={'/potential-matches'}>US HCP Multi Match Review</Button>
                </>}

                <Tooltip disableFocusListener title="Back" id="tooltip">
                  <IconButton aria-label="back"
                    className="text-danger float-end"
                    onClick={goBack} color="secondary">
                    <ArrowBackIcon sx={{transform: direction==='rtl'?'rotate(180deg)':''}} />
                  </IconButton>
                </Tooltip>
                <IconButton aria-label="home" onClick={goToHome} className=' float-end'
                  color="secondary">
                  <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                    <HomeIcon className="text-danger "
                  />
                  </Tooltip>
                </IconButton>
              </Stack>
            </Stack>
          </Paper>
          <div className="outlet">
            <Stack direction="row" justifyContent="space-between" alignItems="center" className="search-bar mx-3 py-2">
              <Stack direction="row" alignItems="center">
                <SearchIcon style={{ color: 'grey', fontSize: '20px', marginRight: '4px' }} />
                <TextField id="standard-basic"
                  type="text"
                  className="placeholder-text"
                  placeholder={'Type here to filter the requests...'} style={{ width: '380px' }} variant="standard" value={searchTerm} onChange={handleSearch} />
              </Stack>
              <Stack direction="row" alignItems="center" gap={1} style={{ minWidth: '200px' }}>
                <FormControl fullWidth className='_wg-dynamic-text' size='small' variant='outlined'
                // sx={{'& .MuiOutlinedInput-root': { '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976D2', borderWidth:'3px' } }}}

                >
                  <InputLabel id='dcr-action'>Time Interval</InputLabel>
                  <Select
                    labelId='dcr-action'
                    id='action'
                    value={searchData.timeInterval}
                    label='Time Interval'
                    name='timeInterval'
                    onChange={handleTimeIntervalChange}
                    className='_wg-dynamic-text'
                    input={
                      <OutlinedInput
                        label='Time Interval'
                      />}
                  >
                    <MenuItem className='_wg-dynamic-text' value={'Last 7 Days'}>Last 7 Days</MenuItem>
                    <MenuItem className='_wg-dynamic-text' value={'Last 15 Days'}>Last 15 Days</MenuItem>
                    <MenuItem className='_wg-dynamic-text' value={'Last 1 Month'}>Last 1 Month</MenuItem>
                    <MenuItem className='_wg-dynamic-text' value={'Last 3 Months'}>Last 3 Months</MenuItem>
                    <MenuItem className='_wg-dynamic-text' value={'All'}>All</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead className='_wg-dynamic-text'>
                    <TableRow>
                      <TableCell className='font' align="center"><Typography variant='subtitle1' className='fw-bold' value={data}>Request Id</Typography></TableCell>
                      <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold' >Created Time  </Typography></TableCell>
                      <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'> Updated Time</Typography></TableCell>
                      <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>Status</Typography></TableCell>
                      <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>Request Type</Typography></TableCell>
                        <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>Created By</Typography></TableCell>
                      <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>Requester Email</Typography></TableCell>
                      <TableCell align="center" className='font'><Typography variant='subtitle1' className='fw-bold'>View Detail</Typography></TableCell>

                      <TableCell />
                    </TableRow>
                </TableHead>
                {activeTab === "VendorRequest" ?
                  <TableBody>
                    {
                      searchTerm && filteredVendorData.length === 0 ? (
                        <TableRow  className='_wg-dynamic-text'>
                          <TableCell colSpan={9} align="center">
                            No Request Found
                          </TableCell>
                        </TableRow>
                      ) : (!searchTerm && vendorTabData.length === 0) ? (
                        <TableRow className='_wg-dynamic-text'>
                          <TableCell colSpan={9} align="center">
                            {searchData?.timeInterval === 'All'
                              ? 'No requests found.'
                              : 'No requests found for the given interval. Try changing the time interval to fetch requests.'}
                          </TableCell>
                        </TableRow>
                      ) : (
                        // (searchTerm ? filteredVendorData : vendorDataPaginated).map((row) => (
                          vendorDataPaginated?.map((row) => (
                          <TableRow key={row.Id}>
                            <TableCell align="left" component="th" scope="row">{row.Id}</TableCell>
                            <TableCell align="left">{row.CreatedDate}</TableCell>
                            <TableCell align="left">{(row.ActionDate !== null && row.ActionDate !== undefined) ? row.ActionDate : (row.UpdatedDate || row.updateTime)}</TableCell>
                            <TableCell align="center"><span className={`${getStatusClassdcr(row.state)} statusWidth`}>{row.state === 'AWAITING_REVIEW' ? 'AWAITING REVIEW' : row.state} </span></TableCell>
                            <TableCell align="center" className='_wg-exclude'>{row.RequestType}</TableCell>
                            <TableCell align="center" className='_wg-exclude'>{row?.RequestorName && row?.CreatedBy ? `${row.RequestorName.includes(" - Network") ? row.RequestorName.split(" - Network")[0].trim() : row.RequestorName} (${row.CreatedBy})` : row?.CreatedBy || row?.RequestorName ||'N/A'}</TableCell> 
                            <TableCell align="center" className='_wg-exclude'>{row?.RequestorEmail ? row.RequestorEmail : 'N/A'}</TableCell>
                            {row.RequestType === 'Merge' &&
                              <TableCell align="center" className='_wg-dynamic-text'><Button className='linkButton' onClick={() => history.push({pathname: `/track-mergeDetail/${row.Id}`})}>View details</Button></TableCell>
                            }
                            {(row.RequestType === 'DCR') &&
                              <TableCell align="center" className='_wg-dynamic-text'>
                                {/* if row.managed_by is VNETWORK link to vnDetail, otherwise link to iqviaDetail(as default)  */}
                                {row.managed_by === 'VNETWORK' ?
                                  <Button className='linkButton'
                                    component={Link} to={`/track-vnDetail/${row.Id}`}>View details</Button>
                                  : row.managed_by === 'OPEN-DATA' ?
                                    <Button className='linkButton'
                                    component={Link} to={`/view-all/requests/${row.Id}/${row.managed_by}`}>View details</Button> 
                                  :<Button className='linkButton'
                                    component={Link} to={`/track-iqviaDetail/${row.Id}`}>View details</Button>}
                              </TableCell>
                            }
                            {(row.RequestType === 'Subscription') &&
                              <TableCell align="center" className='_wg-dynamic-text'><Button className='linkButton' onClick={() => history.push({pathname:`/track-subscribedDetail/${((row.Id))}`})}>View details</Button></TableCell>
                            }
                          </TableRow>
                        )))}
                  </TableBody> :
                  <TableBody>
                    {searchTerm && filteredReltioData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No Request Found
                        </TableCell>
                      </TableRow>
                    ) : (!searchTerm && reltioTabData.length === 0) ? (
                      <TableRow className='_wg-dynamic-text'>
                        <TableCell colSpan={9} align="center">
                          {searchData?.timeInterval === 'All'
                            ? 'No requests found.'
                            : 'No requests found for the given interval. Try changing the time interval to fetch requests.'}
                        </TableCell>
                      </TableRow>
                    )
                      : (
                        // (searchTerm ? filteredReltioData : reltioDataPaginated).map((row) => (
                          reltioDataPaginated?.map((row) => (
                          <TableRow key={row.Id} >
                            <TableCell align="left" component="th" scope="row">{row.Id}</TableCell>
                            <TableCell align="left">{row.CreatedDate}</TableCell>
                            <TableCell align="left">{(row.ActionDate !== null && row.ActionDate !== undefined) ? row.ActionDate : row.UpdatedDate}</TableCell>
                            <TableCell align="center"><span className={`${getStatusClassdcr(row.state)} statusWidth`}>{row.state === 'AWAITING_REVIEW' ? 'AWAITING REVIEW' : row.state} </span></TableCell>
                            <TableCell align="center" className='_wg-exclude'>{row.RequestType}</TableCell>
                            <TableCell align="center" className='_wg-exclude'>{row?.RequestorName && row?.CreatedBy ? `${row.RequestorName.includes(" - Network") ? row.RequestorName.split(" - Network")[0].trim() : row.RequestorName} (${row.CreatedBy})` : row?.CreatedBy || row?.RequestorName ||'N/A'}</TableCell> 
                            <TableCell align="center" className='_wg-exclude'>{row?.RequestorEmail ? row.RequestorEmail : 'N/A'}</TableCell> 
                            {row.RequestType === 'Merge' &&
                              <TableCell align="center" className='_wg-dynamic-text'><Button className='linkButton' onClick={() => history.push({pathname:`/track-mergeDetail/${row.Id}`})}>View details</Button></TableCell>
                            }
                            {row.RequestType === 'DCR' &&
                              <TableCell align="center" className='_wg-dynamic-text'><Button className='linkButton' onClick={() => history.push({pathname:`/view-all/requests/${row.Id}/${row.managed_by}`})}>View details</Button></TableCell>
                            }
                          </TableRow>
                        )))}
                  </TableBody>}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 15, 25]}
              component="div"
              count={
                activeTab === 'VendorRequest'
                  ? searchTerm
                    ? filteredVendorData.length
                    : vendorTabData.length
                  : searchTerm
                    ? filteredReltioData.length
                    : reltioTabData.length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              id="track-head"
              backIconButtonProps={{
                disabled: 
                // searchTerm || 
                page === 0 
                // || paginationDisabled,
              }}
              nextIconButtonProps={{
                disabled:
                  // searchTerm ||
                  page >=
                  Math.ceil(
                    (activeTab === 'VendorRequest'
                      ? searchTerm
                        ? filteredVendorData.length
                        : vendorTabData.length
                      : searchTerm
                        ? filteredReltioData.length
                        : reltioTabData.length) / rowsPerPage
                  ) -
                  1 
                  // || paginationDisabled,
              }}
            />
          </div>
        </>
      }
    </section>
  );
};
export default TrackRequest;